import * as QRCode from "qrcode";

export async function generateQR(
  value: string,
  color: string = "#000000"
): Promise<string> {
  try {
    return await QRCode.toDataURL(value, {
      width: 200,
      margin: 2,
      color: {
        dark: color,
        light: "#FFFFFF",
      },
    });
  } catch (error) {
    console.error("QR generation failed", error);
    return "";
  }
}
